import { UserAmilearnStatus } from '../core/services/user/user.type';

export enum AppRoute {
  WELCOME = 'welcome',
  NEW_USER = 'new-user',
  REGISTERED_USER = 'registered-user',
  SUBSCRIBED_USER = 'subscribed-user',
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  ERROR_PAGE = 'error',
  APP_LOGIN = 'login',
  APP_START = 'early-access',
  APP_LOGOUT = 'logout',
}

export const userStatusRoutingTable: Record<UserAmilearnStatus, AppRoute> = {
  [UserAmilearnStatus.NEW]: AppRoute.NEW_USER,
  [UserAmilearnStatus.REGISTERED]: AppRoute.REGISTERED_USER,
  [UserAmilearnStatus.DEMO]: AppRoute.SUBSCRIBED_USER,
  [UserAmilearnStatus.SUBSCRIBED]: AppRoute.SUBSCRIBED_USER,
};

export const cookieConsentAllowedRoutes: AppRoute[] = [
  AppRoute.WELCOME,
  // AppRoute.REGISTERED_USER,
]

export const openAppRoutes = [AppRoute.PRIVACY_POLICY, AppRoute.TERMS_AND_CONDITIONS];
